<template>
  <div class="home">
    <div class="background"></div>
    <div class="header">
      <Menu />
    </div>
    <div class="text-title">
      <div class="text-background">
        <h1>
          <img src="../assets/versada.png" width="250px" alt="Versada" />
        </h1>
        <h2>Tu inmobiliaria de confianza</h2>
      </div>
    </div>
    <div class="container">
      <b-modal id="notificactionModal" title="Todo va a salir bien" centered size="xl" hide-footer>
        <b-row>
          <b-col cols=12 lg=6>
            <p>Hola a Tod@s,</p>
            <p>Espero y deseo que estéis bien.</p>
            <p>Por nuestros mayores, familias, amigos y clientes, por tí por mí, Versada Inmobiliaria volverá a la actividad a partir de Mayo si es posible.
              De todas formas, podéis comunicaros conmigo a través de la web</p>
            <p>YO ME QUEDO EN CASA.</p>
          </b-col>
          <b-col cols=12 lg=6>
            <b-img src="/img/notification-image.jpg" fuild alt="todo va a salir bien" />
          </b-col>
        </b-row>
      </b-modal>
      <Search :horizontal="true" />
      <Carousel title="Propiedades destacadas" :properties="properties" />
      <About />
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from "@/components/Menu";
import Search from "@/components/Search";
import Carousel from "@/components/Carousel";
import About from "@/components/About";
import Footer from "@/components/Footer";
import PropertyRepository from "@/repositories/PropertyRepository";

export default {
  name: "Home",
  components: {
    Menu,
    Search,
    Carousel,
    About,
    Footer
  },
  data() {
    return {
      properties: [],
    };
  },
  metaInfo() {
    return {
      title: "Tu inmobiliaria en Pontevedra de confianza " + process.env.VUE_APP_META_TITLE,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "Versada inmobiliaria, tu inmobiliaria en Pontevedra de confianza, contacta con nosotros para encontrar el piso de tus sueños. Disponemos de pisos, casas, locales, oficinas, garajes y fincas en venta y alquiler"
        }
      ],
      link: [
        {
          rel: "canonical",
          href: process.env.VUE_APP_LINK + this.$route.path
        }
      ]
    };
  },
  created() {
    this.getHomeProperties();
  },
  methods: {
    async getHomeProperties() {
      let params = { limit: 9, propertyType: 1, highlighted: 1 };
      const { data } = await PropertyRepository.search(params);
      this.properties = data;
      this.showNotification()
    },
    showNotification () {
      // this.$bvModal.show('notificactionModal')
      return true;
    }
  },
};
</script>

<style>
.background {
  background-image: url("../assets/principal.jpg");
  background-repeat: repeat-x;
  position: relative;
  top: -90px;
  width: 100%;
  height: 900px;
  z-index: -1;
}

.text-title {
  color: #0085ca;
  text-align: center;
  margin-top: -540px;
  margin-bottom: 150px;
}
.text-background {
  background-color: #ffffffa8;
  padding: 15px;
}
</style>